import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { getUserSession } from "utils/userUtils";
import bannerAPI from "apis/BannerAPI";

function Banner() {
  const [banner, setBanner] = useState({
    open: false,
    id_banner: "",
    url: "",
    data_expiracao: "",
    modulo: "",
  });

  useEffect(() => {
    if (window.sessionStorage.getItem("expiredValidity")) return;

    bannerAPI
      .getBanner(getUserSession().cnpj)
      .then((response) => {
        setBanner({
          ...response.data,
          open: false,
        });

        let dont_show_banner = localStorage.getItem("dont_show_banner");

        if (dont_show_banner !== null) {
          dont_show_banner = JSON.parse(dont_show_banner);

          if (!dont_show_banner?.includes(response.data.id_banner)) {
            setBanner({ ...response.data, open: true });
          }
        } else {
          setBanner({ ...response.data, open: true });
        }
      })
      .catch((_error) => {
        console.log("Nenhum banner disponível");
      });
  }, []);

  const handleDontShowAgain = () => {
    try {
      setBanner({ ...banner, open: false });
      let banner_storage_data = localStorage.getItem("dont_show_banner") ?? "";
      let dont_show_banner = JSON.parse(banner_storage_data);
      dont_show_banner.push(banner.id_banner);
    } catch (e) {
      localStorage.setItem("dont_show_banner", JSON.stringify([banner.id_banner]));
    }
  };

  return (
    <Dialog open={banner.open} maxWidth="sm" fullWidth={true}>
      <DialogContent>
        <iframe src={banner.url} style={{ width: "100%", height: "75vh", border: "none" }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleDontShowAgain()}>Não mostrar novamente</Button>
        <Button onClick={() => setBanner({ ...banner, open: false })}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
export default Banner;
